module.exports = __webpack_public_path__ + "img/OLD_egg_wind.f0a38972.svg";